import './index.css';

function Loading() {
  return (
    <div id="outer">
      <span id="dote" />
      <div id="middle">
        <div id="inner" />
      </div>
    </div>
  );
}

export default Loading;
